import { render, staticRenderFns } from "./AddToCartPopinCds.vue?vue&type=template&id=1829247c&scoped=true"
import script from "./AddToCartPopinCds.vue?vue&type=script&lang=js"
export * from "./AddToCartPopinCds.vue?vue&type=script&lang=js"
import style0 from "./AddToCartPopinCds.vue?vue&type=style&index=0&id=1829247c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1829247c",
  null
  
)

export default component.exports